// extracted by mini-css-extract-plugin
export default {"container":"rightDecorativeInputField_container__FiPIg","titleWrapper":"rightDecorativeInputField_titleWrapper__FQHWw"};